<template>
    <div id="search-container" class="container">
        <div class="row filter-row">
            <div class="col-lg-3 col-md-12 filter-col" :class="{'mobile-opaque':showing}">
                <b-collapse id="filter-options" @show="filtersShowing" @hidden="filtersHiding">
                    <div>
                        <div class="heading">
                            <span>Filters</span>
                            <a @click="resetFilters">Reset</a>
                        </div>
                        <div v-if="locale === 'nz'" class="filter-block">
                            <a class="collapse-handle" data-toggle="collapse" href="#types-list" role="button" aria-expanded="true" aria-controls="types-list">
                                Type
                                <b-icon-plus/>
                                <b-icon-dash/>
                            </a>
                            <div id="types-list" class="collapse show" :class="{show:filterType}">
                                <div class="filter-content">
                                    <a :class="{selected:!filterType}" class="btn btn-hollow" @click="changeType(null)">All</a>
                                    <a :class="{selected:filterType === 'image'}" class="btn btn-hollow" @click="changeType('image')">Images</a>
                                    <a :class="{selected:filterType === 'video'}" class="btn btn-hollow" @click="changeType('video')">Videos</a>
                                </div>
                            </div>
                        </div>
                        <div class="filter-block">
                            <a
class="collapse-handle" data-toggle="collapse" href="#genre-search" role="button" aria-expanded="true"
                               aria-controls="genre-search"
>
                                Genre
                                <b-icon-plus/>
                                <b-icon-dash/>
                            </a>
                            <div id="genre-search" class="collapse show">
                                <div class="filter-content">
                                    <multiselect
v-model="filterGenre" :options="genres" label="name" track-by="id" :searchable="false" :multiple="false"
                                                 :taggable="false" :show-labels="false"
/>
                                </div>
                            </div>
                        </div>
                        <div class="filter-block">
                            <a
class="collapse-handle" data-toggle="collapse" href="#orientations-list" role="button" aria-expanded="true"
                               aria-controls="orientations-list"
>
                                Orientation
                                <b-icon-plus/>
                                <b-icon-dash/>
                            </a>
                            <div id="orientations-list" class="collapse show" :class="{show:filterOrientation}">
                                <div class="filter-content">
                                    <a :class="{selected:!filterOrientation}" class="btn btn-hollow" @click="changeOrientation(null)">All</a>
                                    <a :class="{selected:filterOrientation === 'portrait'}" class="btn btn-hollow" @click="changeOrientation('portrait')">Portrait</a>
                                    <a :class="{selected:filterOrientation === 'landscape'}" class="btn btn-hollow" @click="changeOrientation('landscape')">Landscape</a>
                                </div>
                            </div>
                        </div>
                        <div class="filter-block">
                            <a
class="collapse-handle" data-toggle="collapse" href="#photographer-search" role="button" aria-expanded="true"
                               aria-controls="photographer-search"
>
                                Photographer {{ locale === 'nz' ? '/ Videographer' : '' }}
                                <b-icon-plus/>
                                <b-icon-dash/>
                            </a>
                            <div id="photographer-search" class="collapse show">
                                <div class="filter-content">
                                    <multiselect
v-model="filterPhotographer" :options="photographers" placeholder="Start typing name"
                                                 label="name" track-by="id" :searchable="true" :multiple="false" :taggable="false" :show-labels="false"
                                    >
                                        <template slot="noResult">
                                            We don't have anyone by that name
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="filter-block">
                            <nuxt-link :to="{ name: 'pre-purchase' }" class="side-link" target="_blank">
Discounts &amp; Pricing <span><b-icon-arrow-up-right/></span>
                            </nuxt-link>
                        </div>
                        <div v-if="locale === 'nz'" class="filter-block">
                            <nuxt-link :to="{ name: 'tailored' }" class="side-link" target="_blank">
Custom Production Service <span><b-icon-arrow-up-right/></span>
                            </nuxt-link>
                        </div>
                        <div class="filter-block request">
                            <h3>Need that <br>perfect {{ locale === 'nz' ? 'image/video' : 'image' }}?</h3>
                            <a @click="showRequest = true">Request it here ></a>
                        </div>
                    </div>
                </b-collapse>
                <div id="filter-toggles">
                    <a v-b-toggle.filter-options class="w-100 d-block text-center">
                        <span class="when-open">
                            <b-icon-chevron-double-up class="mr-4"/>
                            Close Filters
                            <b-icon-chevron-double-up class="ml-4"/>
                        </span>
                        <span class="when-closed">
                            <b-icon-chevron-double-down class="mr-4"/>
                            Filter Results
                            <b-icon-chevron-double-down class="ml-4"/>
                        </span>
                    </a>
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div id="search-results-container">
                    <div v-if="didYouMean" id="did-you-mean-container">
                        Did you mean: <a @click="changeSearch" v-html="didYouMean.highlighted"/>
                    </div>
                    <div v-show="showRequest" class="request-wrap">
                        <h3 class="col-12 col-md-11">
                            We're brand new and adding to our fast growing library every day. Let us know what you need and we'll be in touch.
                        </h3>
                        <request-image-form
:search-term="searchTerm" :filter-options="{ filterOrientation: filterOrientation,
                                                                                         filterGenre: filterGenre,
                                                                                         filterLocation: filterLocation,
                                                                                         filterPhotographer: filterPhotographer}" @cancel="showRequest = false"
                        />
                    </div>
                    <div
                        v-show="!showRequest && (!filterPriceTier || (filterPriceTier && contributorResults.length > 0) || (filterPriceTier && stockResults.length === 0))"
                        class="similar-images-wrap" style="display:flex"
>
                        <div v-if="contributorResults.length > 0" id="contributor-results">
                            <div class="search-heading">
                                Contributor name matches
                            </div>
                            <div id="contributor-results-inner">
                                <contributor-banner v-for="contributor in contributorResults" :key="contributor.id" :contributor="contributor"/>
                            </div>
                        </div>
                        <template v-if="!filterPriceTier">
                            <div v-if="contributorResults.length > 0" class="search-heading">
                                Stock {{ filterType ? filterType : 'image and video' }} results
                            </div>
                            <stock-image-thumbnail v-for="image in stockResults" :key="image.id" :image="image" :show-in-album-link="showInAlbumLink"/>
                        </template>
                        <div
v-if="requests > 0 && !searching && !searchingContributors && stockResults.length === 0 && contributorResults.length === 0"
                             class="no-results"
>
                            <div class="request-wrap">
                                <h3 class="col-12 col-md-11">
                                    <strong>Looks like we don’t have stock{{ searchTypeText() }} matching your criteria yet.</strong> We're brand new and adding
                                    to our fast growing library every day. Let us
                                    know what you need and we'll be in touch.
                                </h3>
                                <request-image-form
:search-term="searchTerm" :filter-options="{ filterOrientation: filterOrientation,
                                                                                                 filterLocation: filterLocation,
                                                                                                 filterPhotographer: filterPhotographer}" :show-cancel="false"
                                                    @cancel="showRequest = false"
                                />
                            </div>
                        </div>
                    </div>
                    <template v-if="filterPriceTier">
                        <div
v-for="stockPriceTierBlock in stockResultsByPriceTier" :key="stockPriceTierBlock.priceTierId" class="similar-images-wrap"
                             style="display:flex"
>
                            <div class="search-heading">
                                <span class="price-tier-dot" :style="{'background-color': priceTiers[stockPriceTierBlock.priceTierId].color}">&nbsp;</span>
                                Results from {{ priceTiers[stockPriceTierBlock.priceTierId].name }} pricing tier
                            </div>
                            <div v-if="stockPriceTierBlock.stockItems.length === 0" class="price-tier-no-results">
                                We don't currently have anything matching your query in the {{ priceTiers[stockPriceTierBlock.priceTierId].name }} pricing tier.
                            </div>
                            <stock-image-thumbnail
v-for="image in stockPriceTierBlock.stockItems" :key="image.id" :image="image"
                                                   :show-in-album-link="showInAlbumLink"
/>
                        </div>
                    </template>
                    <div v-if="(searching || searchingContributors) && state === 'initial'" class="loading d-block">
                        <div class="loading-content-wrap mt-4">
                            <div class="spinner-border align-self-center text-primary" role="status">
                                <span class="sr-only">Searching library</span>
                            </div>
                            <div class="loading-message">
                                Searching library
                            </div>
                        </div>
                    </div>
                    <div v-if="state !== 'initial' && stockResults.length > 0 && !noMoreResults" class="d-block">
                        <v-button
:loading="searching" class="btn-default btn-hollow w-auto pt-3 pb-3 mt-4 pl-5 pr-5 d-block ml-auto mr-auto h6"
                                  @click.native="doSearch"
>
                            Load more results
                        </v-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import StockImageThumbnail from '~/components/StockImageThumbnail'
import RequestImageForm from '~/components/RequestImageForm'
import ContributorBanner from '~/components/ContributorBanner'

export default {
    components: {
        ContributorBanner,
        StockImageThumbnail,
        RequestImageForm
    },
    async asyncData () {
        const response = {}

        await axios.get('/stock-images/search/filter-data')
            .then(rsp => rsp.data)
            .then((rsp) => {
                response.photographers = rsp.photographers
                response.genres = rsp.genres
            })

        return response
    },
    data () {
        return {
            searching: false,
            searchingContributors: false,
            stockResults: [],
            stockResultsByPriceTier: [],
            contributorResults: [],
            photographers: [],
            genres: [],
            searchTerm: null,
            axiosSource: null,
            filterType: null,
            filterGenre: null,
            filterOrientation: null,
            filterLocation: null,
            filterPhotographer: null,
            filterPriceTier: null,
            page: 1,
            requests: 0,
            showRequest: false,
            redirecting: false,
            noMoreResults: false,
            state: 'initial',
            showInAlbumLink: true,
            randomSeed: Math.floor(Math.random() * 1000),
            showing: false,
            didYouMean: null,
            min_score: 0.4
        }
    },
    head () {
        let title = ''
        let description = ''

        if (this.$route.query.term) {
            const term = this.$route.query.term.trim()
            const searchType = this.searchTypeText()

            if (/similar to:#?TS\d{6}$/gi.exec(term)) {
                title = `Stock ${searchType} similar to #${term.replace(/similar to:#?/, '')} | Truestock ${this.locale === 'nz' ? 'New Zealand' : 'Australia'}`
                description = `Find authentic ${this.locale === 'nz' ? 'New Zealand' : 'Australian'} stock ${searchType} similar to #${term.replace(/similar to:#?/, '')} on Truestock`
            } else if (/in album with:#?TS\d{6}$/gi.exec(term)) {
                title = `Stock ${searchType} in album with #${term.replace(/in album with:#?/, '')} | Truestock ${this.locale === 'nz' ? 'New Zealand' : 'Australia'}`
                description = `Browse ${this.locale === 'nz' ? 'New Zealand' : 'Australian'} stock ${searchType} in album with #${term.replace(/in album with:#?/, '')}`
            } else {
                title = `${this.searchTerm} stock ${searchType} | Truestock ${this.locale === 'nz' ? 'New Zealand' : 'Australia'}`
                description = `Find authentic ${this.locale === 'nz' ? 'New Zealand' : 'Australian'} stock ${searchType} for "${this.searchTerm}". Royalty-free, locally sourced imagery.`
            }
        } else {
            title = this.locale === 'nz' ? 'Search authentic Aotearoa stock images | Truestock New Zealand' : 'Search authentic Australian stock images | Truestock Australia'
            description = this.locale === 'nz' ? 'Search thousands of authentic New Zealand stock images capturing diverse Aotearoa life. Royalty-free, locally sourced photography.' : 'Search thousands of authentic Australian stock images capturing diverse Australian life. Royalty-free, locally sourced photography.'
        }

        return {
            title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: description
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: description
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: description
                },
                {
                    name: 'robots',
                    content: 'index, follow'
                }
            ],
            link: [
                {
                    rel: 'canonical',
                    href: `${process.env.appUrl}${this.$route.path}${this.$route.query ? '?' + new URLSearchParams(this.$route.query).toString() : ''}`
                }
            ]
            // TODO look more into this
            // script: [
            //     {
            //         type: 'application/ld+json',
            //         json: {
            //             '@context': 'https://schema.org',
            //             '@type': 'SearchResultsPage',
            //             name: title,
            //             description,
            //             url: `${process.env.appUrl}${this.$route.path}`,
            //             mainEntity: {
            //                 '@type': 'ItemList',
            //                 numberOfItems: this.stockImages.length,
            //                 itemListElement: this.stockImages.slice(0, 10).map((image, index) => ({
            //                     '@type': 'ImageObject',
            //                     position: index + 1,
            //                     name: image.title || `Stock image ${image.code}`,
            //                     contentUrl: image.thumbnail_url,
            //                     description: `Authentic ${this.locale === 'nz' ? 'New Zealand' : 'Australian'} stock image`,
            //                     creator: {
            //                         '@type': 'Person',
            //                         name: image.photographer_name
            //                     }
            //                 }))
            //             }
            //         }
            //     }
            // ]
        }
    },
    computed: {
        ...mapGetters({
            priceTiers: 'data/priceTiers'
        }),
        priceTiersSorted () {
            const values = Object.values(this.priceTiers)
            values.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))

            return values
        }
    },
    watch: {
        $route (to, from) {
            this.configureAndSearch(to.query)
        },
        filterGenre (val, oldVal) {
            this.setNewSearchQuery()
        },
        filterPhotographer (val, oldVal) {
            this.setNewSearchQuery()
        }
    },

    created (redirect) {
        let term = ''

        if (this.$route.query.term && this.$route.query.term !== '') {
            term = this.$route.query.term.trim()

            if (!/similar to:#?TS\d{6}$/gi.exec(term) && !/in album with:#?TS\d{6}$/gi.exec(term)) {
                term = /#?TS\d{6}/gi.exec(this.$route.query.term.trim())

                if (term && term.length > 0) {
                    term = term[0]
                }

                if (term && term.length > 0) {
                    this.redirecting = true
                    this.$router.push({
                        name: 'stock-image',
                        params: { image_id: term.replace('#', '').toUpperCase() }
                    }).catch((e) => {
                    })
                }
            }
        }

        if (this.$route.query.min_score) {
            this.min_score = this.$route.query.min_score
        }
    },

    mounted () {
        this.configureAndSearch(this.$route.query)
    },

    methods: {
        changeSearch () {
            this.$nuxt.$emit('newSearch', this.didYouMean.text)
        },
        selectPriceTier (priceTier) {
            this.filterPriceTier = priceTier

            this.setNewSearchQuery()
        },
        filtersShowing () {
            this.showing = true

            this.$nuxt.$emit('mobileOpaque', true)
        },
        filtersHiding () {
            this.showing = false

            this.$nuxt.$emit('mobileOpaque', false)
        },
        searchTypeText () {
            return !this.filterType || this.filterType === 'all' ? ' ' : ` ${this.filterType}s `
        },
        resetFilters () {
            this.filterOrientation = this.filterGenre = this.filterLocation = this.filterPhotographer = null
            this.setNewSearchQuery()
        },
        configureAndSearch (query) {
            let term = ''

            if (this.$route.query.term !== null && this.$route.query.term !== undefined) {
                term = this.$route.query.term.trim()

                if (!/similar to:#?TS\d{6}$/gi.exec(term) && !/in album with:#?TS\d{6}$/gi.exec(term)) {
                    term = /#?TS\d{6}/gi.exec(query.term.trim())

                    if (term && term.length > 0) {
                        term = term[0]
                    }

                    if (term && term.length > 0) {
                        this.$router.push({
                            name: 'stock-image',
                            params: { image_id: term.replace('#', '').toUpperCase() }
                        }).catch((e) => {
                        })
                    }

                    this.showInAlbumLink = !/in album with:#?TS\d{6}/gi.exec(query.term.trim())
                }

                this.searchTerm = query.term
            }

            this.filterType = query.type
            this.filterOrientation = query.orientation

            this.filterGenre = (query.genre)
                ? this.genres.find((genre) => {
                    return genre.id === parseInt(query.genre)
                })
                : null

            this.filterLocation = (query.lat && query.lng)
                ? {
                    lat: query.lat,
                    lng: query.lng,
                    location: query.location
                }
                : null

            this.filterPhotographer = (query.photographer)
                ? this.photographers.find((photographer) => {
                    return photographer.id === query.photographer
                })
                : null

            this.filterPriceTier = (query.price_tier) ? this.priceTiers[query.price_tier] : null

            this.stockResultsByPriceTier = []
            this.page = 1
            this.requests = 0
            this.stockResults = []
            this.contributorResults = []
            this.noMoreResults = false
            this.state = 'initial'
            this.randomSeed = Math.floor(Math.random() * 1000)
            this.didYouMean = null

            this.doSearch()
            this.doContributorSearch()
        },
        setNewSearchQuery () {
            const searchQuery = {}

            if (this.searchTerm) {
                searchQuery.term = this.searchTerm
            }

            if (this.filterType) {
                searchQuery.type = this.filterType
            }

            if (this.filterOrientation) {
                searchQuery.orientation = this.filterOrientation
            }

            if (this.filterGenre) {
                searchQuery.genre = this.filterGenre.id
            }

            if (this.filterLocation) {
                searchQuery.lat = this.filterLocation.lat
                searchQuery.lng = this.filterLocation.lng
                searchQuery.location = this.filterLocation.location
            }

            if (this.filterPhotographer) {
                searchQuery.photographer = this.filterPhotographer.id
            }

            if (this.filterPriceTier) {
                searchQuery.price_tier = this.filterPriceTier.id
            }

            if (this.$route.query.state) {
                searchQuery.state = this.$route.query.state
            }

            this.page = 1
            this.requests = 0
            this.noMoreResults = false
            this.state = 'initial'
            this.randomSeed = Math.floor(Math.random() * 1000)

            this.$router.push({ query: searchQuery }).catch(() => {
            })
        },
        doContributorSearch () {
            if (this.searchTerm && !this.redirecting) {
                this.searchingContributors = true

                axios({
                    method: 'get',
                    url: '/contributor/search',
                    params: {
                        searchTerm: this.searchTerm
                    }
                }).then(rsp => rsp.data.data)
                    .then((rsp) => {
                        this.contributorResults = rsp
                    })
                    .finally(() => {
                        this.searchingContributors = false
                    })
            }
        },
        doSearch () {
            if (!this.redirecting) {
                if (this.searching) {
                    this.axiosSource.cancel()
                }
                this.requests++
                this.searching = true

                this.axiosSource = axios.CancelToken.source()
                axios({
                    method: 'get',
                    url: '/stock-images/search',
                    params: {
                        page: this.page,
                        searchTerm: this.searchTerm,
                        type: this.filterType,
                        orientation: this.filterOrientation,
                        contributor: this.filterPhotographer ? this.filterPhotographer.id : null,
                        genre: this.filterGenre ? this.filterGenre.id : null,
                        location: this.filterLocation,
                        priceTierId: this.filterPriceTier ? this.filterPriceTier.id : null,
                        randomSeed: this.randomSeed,
                        state: this.$route.query.state,
                        min_score: this.min_score
                    },
                    config: {
                        cancelToken: this.axiosSource.token
                    }
                }).then(rsp => rsp.data)
                    .then((rsp) => {
                        this.didYouMean = rsp.didYouMean

                        if (rsp.data.length) {
                            this.state = 'searched'

                            this.page += 1
                            this.stockResults.push(...rsp.data)

                            if (this.filterPriceTier) {
                                if (this.state === 'initial') {
                                    this.stockResultsByPriceTier = [{
                                        priceTierId: this.filterPriceTier.id,
                                        stockItems: []
                                    }]
                                }

                                this.separateResultsByPriceTier(rsp.data)
                            }

                            if (rsp.meta.current_page === rsp.meta.last_page) {
                                this.noMoreResults = true
                            }
                        } else {
                            this.noMoreResults = true
                        }
                    })
                    .finally(() => {
                        this.searching = false
                    })
            }
        },
        changeType (type) {
            this.filterType = type

            this.setNewSearchQuery()
        },
        changeOrientation (orientation) {
            this.filterOrientation = orientation

            this.setNewSearchQuery()
        },
        separateResultsByPriceTier (fetchedStockItems) {
            if (this.stockResultsByPriceTier.length === 0 && fetchedStockItems[0].price_tier_id !== this.filterPriceTier.id) {
                this.stockResultsByPriceTier.push({
                    priceTierId: parseInt(this.filterPriceTier.id),
                    stockItems: []
                })
            }

            fetchedStockItems.forEach((fetchedStockItem) => {
                let priceTierResultBlockIndex = this.stockResultsByPriceTier.findIndex((resultBlock) => {
                    return resultBlock.priceTierId === parseInt(fetchedStockItem.price_tier_id)
                })

                if (priceTierResultBlockIndex < 0) {
                    priceTierResultBlockIndex = this.stockResultsByPriceTier.push({
                        priceTierId: parseInt(fetchedStockItem.price_tier_id),
                        stockItems: []
                    }) - 1
                }

                this.stockResultsByPriceTier[priceTierResultBlockIndex].stockItems.push(fetchedStockItem)
            })
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
